<template>
  <v-responsive min-width="100" max-width="250">
    <v-text-field
      v-model="searchTerm"
      density="compact"
      :prepend-inner-icon="`mdi-${icon}`"
      variant="solo-filled"
      :placeholder="placeholderField"
      :label="label"
      hide-details="auto"
      @blur="performSearch"
      @keyup.enter="performSearch"
    />
  </v-responsive>
</template>

<script setup lang="ts">
import { computed, Ref, ref, watch, withDefaults } from 'vue'
import { useRoute } from 'vue-router'

import { i18n } from '@/lang/setup'
import routerHandler from '@/router/routerHandler'

type SearchFieldProps = {
  label: string
  searchQuery: string
  placeholder?: string
  icon?: string
}

const route = useRoute()
const props = withDefaults(defineProps<SearchFieldProps>(), {
  icon: 'magnify',
  placeholder: '',
})

const searchTerm: Ref<string> = ref(
  (route.query[props.searchQuery] as string) || ''
)

watch(
  () => route.query,
  () => {
    onRouteChanged()
  }
)

function onRouteChanged() {
  searchTerm.value = (route.query[props.searchQuery] as string) || ''
}

onRouteChanged()

const placeholderField = computed((): string => {
  if (props.placeholder) {
    return props.placeholder
  } else {
    return i18n.global.t('components.common.searchBy') + ' ' + props.label
  }
})

function performSearch() {
  if (searchTerm.value) {
    routerHandler.setQuery('', { [props.searchQuery]: searchTerm.value })
  } else {
    routerHandler.removeFromQuery('', props.searchQuery)
  }
}
</script>

<style lang="scss"></style>
